import { Component, Input } from '@angular/core';
import { CarpaDataTableColumnConfig } from '../../models/carpa-data-table-column-config';

@Component({
    selector: 'app-carpa-data-table-column',
    templateUrl: './carpa-data-table-column.component.html',
    styleUrls: [],
    standalone: false
})
export class CarpaDataTableColumnComponent<T> {
	@Input() item: T;
	@Input() columnConfig: CarpaDataTableColumnConfig<T>;

	getColumnContent(): string {
		if (this.columnConfig.template) {
			return this.columnConfig.template(this.item);
		}
		return this.item[this.columnConfig.key]?.toString() || '';
	}
}
